import { render } from "./CurrentRestaurantMenu.vue?vue&type=template&id=712e559c&scoped=true"
import script from "./CurrentRestaurantMenu.vue?vue&type=script&lang=js"
export * from "./CurrentRestaurantMenu.vue?vue&type=script&lang=js"

import "./CurrentRestaurantMenu.vue?vue&type=style&index=0&id=712e559c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712e559c"]])

export default __exports__